
import React, { Component } from 'react'
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import  BreadCrumb  from "app/components/BreadCrumb";
import { useTranslation } from "react-i18next";
import { useInjectReducer } from "redux-injectors";
import { ActionBar } from "./components/ActionBar"
import { reducer, sliceKey } from "./redux/slice";

import { useStyles } from "./styles";
import InventoryTable from "./components/InventoryTable"
import {
  selectFilteredWorkOrders,
  selectIsLoading,
  selectError
} from "./redux/selector";


const Inventory = () => {
const styles = useStyles();
const { t, i18n } = useTranslation();
const rows = useSelector(selectFilteredWorkOrders)
const loading = useSelector(selectIsLoading) 

useInjectReducer({
  key: sliceKey,
  reducer,
});





    
  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb title={t("SIDEBAR.INVENTORY")} iconPosition="end" />
            <ActionBar></ActionBar>
            <InventoryTable rows={rows} loading={loading} />
          </Box>
        </Box>
    </Box>
  )
}

export default Inventory
